import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validateErrorsFromObject(valueProperty: string, validators: ValidatorFn[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let mappedValue = control.value;
    if (mappedValue && typeof mappedValue === 'object') {
      mappedValue = mappedValue[valueProperty];
    } else {
      return null;
    }

    const mappedControl = { value: mappedValue } as AbstractControl;

    const errors = validators
      .map((validator) => validator(mappedControl))
      .filter((error) => error != null)
      .reduce((combined, error) => ({ ...combined, ...error }), {});

    if (Object.keys(errors).length) {
      for (const key of Object.keys(errors)) {
        errors[key] = { mapped: mappedValue, ...errors[key] };
      }
      return errors;
    }
    return null;
  };
}
